import instance from "http/Manager";

export const check_server = async () => {
  const response = await instance.get("/auth/check");
  if(response.status) {
    if(response.data.server) {
      return response.data.version;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const login_user = (data) => {
  return instance.post("/auth/login", data );
};